﻿import { reportsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("task-list"),
  endpoint: "reports",
  operations: reportsOps,
  baseRoute: "task-list",
  roleView: [ROLE.CUSTOMER_ADMIN, ROLE.CUSTOMER_VIEW],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  singularName: (t) => t("Task list"),
  name: (t) => t("Task lists"),

  syncCustomerFilter: true,
});

export default conf;
